exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._3IEArtRg6jh9ZtxYaCEZbH{height:215px;resize:vertical}\n", ""]);

// Exports
exports.locals = {
	"input": "_3IEArtRg6jh9ZtxYaCEZbH"
};